import { motion } from "framer-motion";
import { Award, ShieldCheck, Layers, Gem, MessagesSquare, Timer } from "lucide-react";

const features = [
  { icon: Award, title: "Professional Approach", body: "Senior leads on every engagement. Clarity from first call to handover." },
  { icon: ShieldCheck, title: "Reliable Execution", body: "Delivery discipline anchored in documented process and sign-offs." },
  { icon: Layers, title: "End-to-End Solutions", body: "Procurement, supply, interiors and execution under one roof." },
  { icon: Gem, title: "Quality Focused", body: "Material specifications, inspection protocols and traceability." },
  { icon: MessagesSquare, title: "Transparent Communication", body: "Weekly status, honest tradeoffs, no last-minute surprises." },
  { icon: Timer, title: "Timely Delivery", body: "Programme management with realistic timelines that we honour." },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[var(--nv-navy)] text-[var(--nv-paper)] py-28 md:py-40 nv-grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <div className="overline text-[var(--nv-gold)] flex items-center gap-3">
              <span className="inline-block w-6 h-px bg-[var(--nv-gold)]" />
              <span>Why Nsoul Ventures</span>
            </div>
            <h2 className="mt-6 display text-5xl md:text-7xl" data-testid="why-heading">
              Six reasons clients <span className="italic text-[var(--nv-gold)]">return.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="why-grid">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.article
                key={f.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1], delay: (i % 3) * 0.06 }}
                className="col-span-12 md:col-span-6 lg:col-span-4 group relative border border-[var(--nv-line-dark)] p-8 md:p-10 hover:border-[var(--nv-gold)] transition-[border-color,transform] duration-500 hover:-translate-y-1"
                data-testid={`why-item-${i}`}
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-[var(--nv-paper)]/30 group-hover:border-[var(--nv-gold)] transition-colors duration-500">
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="font-mono text-[10px] tracking-[0.24em] text-[var(--nv-paper)]/50">0{i + 1}</span>
                </div>
                <h3 className="mt-8 font-serif text-2xl md:text-3xl tracking-tight leading-[1.1]">
                  {f.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[var(--nv-paper)]/70">{f.body}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
